import React, { createContext } from 'react'
import CookiesStorageService from '../Services/CookiesStorageService'
import ListingServices from '../Services/Consumers/ListingServices'
import { useKeycloak } from '@react-keycloak/web'
import { FormattedMessage } from 'react-intl'
import { getQuarterDate, handleNotificationAlert } from '../utils/helpers'
import moment from 'moment'

const DashboardContext = createContext({})

const DashboardProvider = ({ children }) => {
  const { keycloak } = useKeycloak()

  const [isDialogOpen, setIsDialogOpen] = React.useState(false)
  const [filterData, setFilterData] = React.useState({
    dateFrom: getQuarterDate(Math.floor(new Date().getMonth() / 3) + 1, new Date().getFullYear()),
    dateTo: getQuarterDate(Math.floor(new Date().getMonth() / 3) + 1, new Date().getFullYear(), true),
    year: new Date(),
    month: new Date(),
    type: 'quarterly',
    quarter: '1'
  })
  const [dashboardIssuerLoading, setDashboardIssuerLoading] = React.useState(false)
  const [dashboardReceiverLoading, setDashboardReceiverLoading] = React.useState(false)

  const [dashboardIssuerData, setDashboardIssuerData] = React.useState({})
  const [dashboardReceiverData, setDashboardReceiverData] = React.useState({})

  const getDataForDashboard = (reports) =>{
    let data = []
    if(reports?.length){
      reports?.forEach(report =>{
        let reportsData={
          amounts:{},
          stats:{}
        };
        ['i','c','d'].forEach(item =>{
          reportsData.amounts[item]={
            count: report?.amounts[item],
            amount: report?.amounts[`${item}_Amount`],
          }
        })
        Object.keys(report?.stats||{})?.forEach(item =>{
          reportsData.stats[item]={
            count: report?.stats[item],
            amount: report?.amounts[`${item}Amount`],
          }
        })
        data.push(reportsData)
      })
    }
    return data
  }
  const getDashboardData = React.useCallback(() => {
    if (!!keycloak?.authenticated) {
      setDashboardIssuerLoading(true)
      setDashboardReceiverLoading(true)
      let data = {
        'getDocumentsReportRequest': {
          'correlationId': 'e390a1a2-23b8-4592-983d-1625e08f91ab',
          'dateIssuedFrom': moment(filterData?.dateFrom).locale('en-us').format('YYYY-MM-DD') || '',
          'dateIssuedTo': moment(filterData?.dateTo).locale('en-us').format('YYYY-MM-DD') || '',
          'TRN_NMBR': CookiesStorageService.getTaxpayerTRN(),
          'direction': 'submitter'
        }
      }
      ListingServices.getDashboardData(data, setDashboardIssuerLoading, <FormattedMessage
        id='Dashboard.Issuer.FormErrorAlert'/>).then((result) => {
        if (!!result && !!result?.data?.getDocumentsReportResponse?.reports) {
          setDashboardIssuerData(getDataForDashboard(result.data?.getDocumentsReportResponse?.reports))

          // setDashboardIssuerData({
          //   'stats': {
          //     'valid': 100,
          //     'invalid': 20,
          //     'rejected': 10,
          //     'cancelled': 5,
          //     'submitted': 3
          //   },
          //   'amounts': { 'i': 80000.75, 'c': 555.55, 'd': 948.75 }
          // })
          // {
          //   "stats": {
          //   "submitted": 0,
          //     "valid": 6,
          //     "invalid": 0,
          //     "rejected": 0,
          //     "cancelled": 0
          // },
          //   "amounts": {
          //   "submittedAmount": 0,
          //     "validAmount": 41948,
          //     "invalidAmount": 0,
          //     "rejectedAmount": 0,
          //     "cancelledAmount": 0,
          //     "i": 3,
          //     "c": 3,
          //     "d": 0,
          //     "i_Amount": 1668,
          //     "c_Amount": 40280,
          //     "d_Amount": 0
          // }
          // }

        } else {
          handleNotificationAlert({
            type: 'defence',
            message: <FormattedMessage id='Dashboard.Issuer.FormErrorAlert'/>,
            color: 'error'
          }, 'error')
        }
      }).then(() => {
        setDashboardIssuerLoading(false)
      })
      let receiverData = { ...data }
      receiverData.getDocumentsReportRequest.direction = 'receiver'
      ListingServices.getDashboardData(receiverData, setDashboardReceiverLoading, <FormattedMessage
        id='Dashboard.Issuer.FormErrorAlert'/>).then((result) => {
        if (!!result && !!result?.data?.getDocumentsReportResponse?.reports) {
          setDashboardReceiverData(getDataForDashboard(result.data?.getDocumentsReportResponse?.reports))
          // setDashboardReceiverData({
          //   'stats': {
          //     'valid': 20,
          //     'invalid': 10,
          //     'rejected': 50,
          //     'cancelled': 5,
          //     'submitted': 9
          //   },
          //   'amounts': { 'i': 3000, 'c': 5555.55, 'd': 9999 }
          // })
        } else {
          handleNotificationAlert({
            type: 'defence',
            message: <FormattedMessage id='Dashboard.Issuer.FormErrorAlert'/>,
            color: 'error'
          }, 'error')
        }
      }).then(() => {
        setDashboardReceiverLoading(false)
      })

    }
  }, [keycloak, filterData])

  const updateDashboard = (values, FormikActions) => {
    setFilterData({ ...values })
    FormikActions.setSubmitting(false)
    cancelDialog()
  }
  React.useEffect(() => {
      if (!!Object.keys(filterData || {}).length) {
        getDashboardData()
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [filterData])

  const openDialog = () => {
    setIsDialogOpen(!isDialogOpen)
  }

  const cancelDialog = () => {
    setIsDialogOpen(false)
  }


  return (
    <DashboardContext.Provider value={{
      dashboardIssuerLoading,
      dashboardReceiverLoading,

      dashboardIssuerData,
      dashboardReceiverData,

      isDialogOpen,
      openDialog,
      cancelDialog,

      updateDashboard,
      filterData
    }}>
      {children}
    </DashboardContext.Provider>
  )
}
const DashboardConsumer = DashboardContext.Consumer

export { DashboardProvider, DashboardConsumer }
